class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;

    // Close on overlay click
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => this.close());

    // Close on Escape
    this.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });

    this.setHeaderCartIconAccessibility();
    this.bindCartControls();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (e) => {
      e.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (e) => {
      if (e.code === 'Space') { e.preventDefault(); this.open(cartLink); }
    });
  }

  bindCartControls() {
    this.querySelectorAll('.icd-qty').forEach((qtyEl) => {
      const key = qtyEl.dataset.itemKey;
      const valEl = qtyEl.querySelector('.icd-qty__num');
      qtyEl.querySelectorAll('.icd-qty__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const current = parseInt(valEl.textContent, 10) || 0;
          const next = Math.max(0, current + (btn.dataset.action === 'increase' ? 1 : -1));
          this.updateCart(key, next);
        });
      });
    });

    this.querySelectorAll('.icd-item__remove').forEach((btn) => {
      btn.addEventListener('click', () => this.updateCart(btn.dataset.itemKey, 0));
    });
  }

  async updateCart(key, quantity) {
    this.classList.add('cart-loading');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      this.rerenderFromData(data);
    } catch (e) {
      console.error('Cart update error:', e);
    } finally {
      this.classList.remove('cart-loading');
    }
  }

  rerenderFromData(data) {
    if (!data || !data.sections) return;

    const drawerHtml = data.sections['cart-drawer'];
    if (drawerHtml) {
      const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const newInner = parsed.querySelector('#CartDrawer');
      const oldInner = this.querySelector('#CartDrawer');
      if (newInner && oldInner) {
        oldInner.innerHTML = newInner.innerHTML;
        this.bindCartControls();
        const closeBtn = this.querySelector('.icd-close');
        if (closeBtn) closeBtn.onclick = () => this.close();
      }
    }

    if (data.item_count === 0) {
      this.classList.add('is-empty');
    } else {
      this.classList.remove('is-empty');
    }

    const bubbleHtml = data.sections['cart-icon-bubble'];
    if (bubbleHtml) {
      const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const bubble = document.getElementById('cart-icon-bubble');
      const newSection = parsed.querySelector('.shopify-section');
      if (bubble && newSection) bubble.innerHTML = newSection.innerHTML;
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    setTimeout(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active', 'animate');
    document.body.classList.remove('overflow-hidden');
    if (this.activeElement) {
      this.activeElement.focus();
      this.activeElement = null;
    }
  }

  /* Called by cart.js after add-to-cart */
  renderContents(parsedState) {
    this.rerenderFromData(parsedState);
    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => this.close());
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

/* Minimal stub — cart.js expects this class to exist */
class CartDrawerItems extends HTMLElement {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.icd-inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];
  }
}

if (!customElements.get('cart-drawer-items')) {
  customElements.define('cart-drawer-items', CartDrawerItems);
}
